import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { decodeHtmlentities } from '../../../../../../utilities/html';
import { ErrorLabel } from '../../../../../../components/ErrorLabel';
import { ChoosePicture } from './frontImageFieldWrite/ChoosePicture';
import { Icon, TextField } from 'office-ui-fabric-react';
import {
  getFileDimensions,
  resolveFileExtensionFromMime,
} from '../../../../../../utilities/files';
import { resolveValidationRules } from '../../../../../../utilities/validationRuleHelper';

const FrontImageFieldWrite = ({
  fileName,
  altText,
  onChangeFile,
  onChangeText,
  downloadUrl,
  validationEntity,
}) => {
  const { t: translator } = useTranslation();

  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  // filesize in bytes
  const { maxFileSize, allowedFileTypes } = resolveValidationRules(
    validationEntity,
  );

  const isUploading = false;
  const minWidth = 700;
  const minAspectRatio = 1.5;
  const maxAspectRatio = 3.5;
  const allowedFileExtensions = allowedFileTypes?.map(
    resolveFileExtensionFromMime,
  );

  useEffect(() => {
    if (!hasError) {
      setErrorMessage(null);
    }
  }, [hasError]);

  const onChangeFileLocal = async (event) => {
    const [file] = event.target.files;

    const { width, height } = await getFileDimensions(file);
    const aspectRatio = height ? width / height : 0;

    let hasError = true;
    if (file.size === 0) {
      setErrorMessage(
        translator('components.fileComponents.uploadFileErrorEmpty'),
      );
    } else if (file.size > maxFileSize) {
      setErrorMessage(
        translator('components.fileComponents.uploadFileErrorLarge'),
      );
    } else if (width < minWidth) {
      setErrorMessage(
        translator('components.fileComponents.uploadFileErrorWidth'),
      );
    } else if (aspectRatio < minAspectRatio || aspectRatio > maxAspectRatio) {
      setErrorMessage(
        translator('components.fileComponents.uploadFileErrorRatio'),
      );
    } else {
      hasError = false;
      onChangeFile({
        target: {
          files: [file],
        },
      });
    }

    setHasError(hasError);
  };

  const onDeleteFile = () => {
    onChangeFile(
      {
        fileContentUrl: downloadUrl,
        target: {
          files: [
            {
              name: fileName,
            },
          ],
        },
      },
      true,
    );
  };

  return (
    <div
      className="create-hearing-form-field"
      aria-label={translator('ariaLabel.frontImageFieldWrite')}
    >
      <p>{translator('pages.createHearing.chooseImage')}</p>
      <ChoosePicture
        isUploading={isUploading}
        onUploadFile={onChangeFileLocal}
        minWidth={minWidth}
        maxFileSize={maxFileSize}
        minAspectRatio={minAspectRatio}
        maxAspectRatio={maxAspectRatio}
        allowedFileExtensions={allowedFileExtensions}
      />
      {fileName && (
        <div className="create-hearing-front-image">
          <a href={downloadUrl} download={fileName}>
            <span className="light">{decodeHtmlentities(fileName)}</span>
          </a>
          <button
            onClick={onDeleteFile}
            aria-label={translator('components.fileComponents.deleteFile')}
          >
            <Icon iconName="Cancel" styles={removeFileIconStyles} />
          </button>
        </div>
      )}
      {hasError && <ErrorLabel>{errorMessage}</ErrorLabel>}
      {fileName && (
        <TextField
          value={altText}
          onChange={(_, value) => onChangeText(value)}
          label={translator('pages.createHearing.imageAltTextLabel')}
          placeholder={translator(
            'pages.createHearing.imageAltTextPlaceholder',
          )}
        />
      )}
    </div>
  );
};

const removeFileIconStyles = {
  fontSize: '12px',
  color: '#333333',
};

export { FrontImageFieldWrite };
